// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3d7b660c8d6a8c169fa91c04856f90eb14fffc76/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};